import Link from 'next/link';
import React from 'react';

import { BaseLayout, SmokeBg } from '../BaseLayout';
import { Navbar } from '../BaseLayout/Navbar';
import { StandardCard } from '../UI';

export function LayoutLegal({
  title,
  children,
}: {
  title: string;
  children: JSX.Element | JSX.Element[];
}) {
  return (
    <BaseLayout>
      <SmokeBg>
        <Navbar>
          <Link href="/tos" className="nav-link text-white">
            Terms of use
          </Link>
          <Link href="/privacy" className="nav-link text-white">
            Privacy Policy
          </Link>
        </Navbar>
        <div className="relative max-w-screen-xll mx-auto py-12 xll:pt-12 xll:pb-16 relative px-2">
          <StandardCard>{children}</StandardCard>
        </div>
      </SmokeBg>
    </BaseLayout>
  );
}
